import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface PageHeaderProps {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/**
 * Page-level h1 + optional description + optional right-aligned
 * action slot. Used by API Keys / Observability / future pages
 * so the title block looks consistent everywhere.
 */
export function PageHeader({
  title,
  description,
  action,
  className,
}: PageHeaderProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 tablet:flex-row tablet:items-start tablet:justify-between",
        className
      )}
    >
      <div className="min-w-0">
        <h1 className="text-xl font-medium text-ocean-900 desktop:text-2xl">
          {title}
        </h1>
        {description && (
          <p className="mt-1 max-w-2xl text-sm text-neutral-600">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
